<template>
    <v-form ref="form">
        <v-item-group>
            <v-layout row wrap>
                <span class="heading">{{ 'Birthdate' | translation }}</span>
            </v-layout>
            <v-layout row wrap>
                <v-flex xs4>
                    <v-select
                        :items="days"
                        :label="$language.translate('Day')"
                        v-model="day"
                        :disabled="disabled"
                        :solo="inputSolo"
                        :rules="required ? [rules.required] : []"
                    />
                </v-flex>
                <v-flex xs4>
                    <v-select
                        :items="months"
                        :label="$language.translate('Month')"
                        v-model="month"
                        :disabled="disabled"
                        :solo="inputSolo"
                        :rules="required ? [rules.required] : []"
                    />
                </v-flex>
                <v-flex xs4>
                    <v-select
                        :items="years"
                        :label="$language.translate('Year')"
                        v-model="year"
                        :disabled="disabled"
                        :solo="inputSolo"
                        :rules="required ? [rules.required] : []"
                    />
                </v-flex>

                <span v-if="error" class="body-1 red--text ml-2">
                    {{error | translation}}
                </span>
            </v-layout>
        </v-item-group>
    </v-form>
</template>

<script>
export default {
    name: 'BirthdaySelect',
    props: {
        value: {
            type: Object,
            default: {
                day: null,
                month: null,
                year: null,
            },
        },
        minAge: {
            type: Number,
            default: 0,
        },
        maxAge: {
            type: Number,
            default: 150,
        },
        disabled: Boolean,
        inputSolo: Boolean,
        required: Boolean,
    },
    data() {
        return {
            selectedValues: {
                day: null,
                month: null,
                year: null,
            },
            rules: {
                required: value => !!value || 'Dieses Feld wird benötigt und darf nicht leer sein.',
            },
            error: null,
        };
    },
    computed: {
        day: {
            get() {
                return this.selectedValues.day || this.value.day;
            },
            set(val) {
                this.selectedValues.day = val;
                this.emitValue();
            },
        },
        month: {
            get() {
                return this.selectedValues.month || this.value.month;
            },
            set(val) {
                this.selectedValues.month = val;
                this.emitValue();
            },
        },
        year: {
            get() {
                return this.selectedValues.year || this.value.year;
            },
            set(val) {
                this.selectedValues.year = val;
                this.emitValue();
            },
        },
        days() {
            const days = [];
            let day = 1;
            while (days.length < 31) {
                days.push(day++);
            }
            return days;
        },
        months() {
            const months = [];
            let month = 1;
            while (months.length < 12) {
                months.push(month++);
            }
            return months;
        },
        years() {
            const years = [];
            const date = new Date();
            let year = date.getFullYear() - this.minAge;
            let counter = 0;
            while (counter < this.maxAge) {
                years.push(year--);
                counter++;
            }
            return years;
        },
    },
    methods: {
        emitValue() {
            this.error = null;
            this.$emit('input', {
                day: this.day,
                month: this.month,
                year: this.year,
            });
        },
        validate() {
            if (this.$refs.form.validate()) {
                if (this.minAge) {
                    const today = new Date();

                    const birthday = new Date(
                        this.month.toString() + ' ' +
                        this.day.toString() + ' ' +
                        this.year.toString()
                    );

                    const threshold = new Date(today.getTime());
                    threshold.setFullYear(today.getFullYear() - this.minAge);

                    if (birthday > threshold) {
                        this.error = 'You must be older than' + ' ' + this.minAge;
                        return false;
                    }
                }

                return true;
            }

            return false;
        },
    },
};
</script>